/**
 * SEO fallbacks of HomePage (no hydration flicker).
 * index.html hard-codes the same literals; keep in sync. TODO: set the real shop name per project.
 */

/** Fallback title when the backend provides no `SEOTitle`/`Title`. */
export const DEFAULT_PAGE_TITLE = 'Onlineshop';

/**
 * Name of the meta tag `SeoService.writeHeaderHtml` emits once it has written the page metadata
 * (`headerHtml`) into the document. The browser checks it to avoid writing the same content a
 * second time.
 */
export const SEO_SERVER_MARKER_NAME = 'x-seo-server-injected';

/**
 * Name of the meta tag the server render emits once it has written the page snippets
 * (`headerJavaScript`, `bottomBody`, `bottomJavaScript`) into the served HTML. Separate from
 * {@link SEO_SERVER_MARKER_NAME} because the snippets are only written when the consent bridge
 * is in place, while the metadata always is.
 */
export const SEO_SNIPPETS_MARKER_NAME = 'x-seo-snippets-injected';

/**
 * The legacy CS3 cookie banner include. CS4 ships its own vanilla-cookieconsent based banner and
 * would load both, so the snippet is stripped wherever `headerJavaScript` is written out.
 */
export const CS3_COOKIE_BANNER_INCLUDE = '<script type="text/javascript" src="/Scripts/CookieBanner.js"></script>';
